import {Component, EventEmitter, Input, Output} from "@angular/core";
import {CoreComponent} from "../core-component/core.component";
import {FormGroup} from "@angular/forms";
import {Router} from "@angular/router";
import {CoreApiService} from "../../service/core-api.service";
import {SignUpService} from "../../../rg/service/sign-up.service";
import {ForgotPasswordRequestDto, RegistrationRequestOtpDto} from "../../../rg/types/registration.types";
import {RegistrationApiService} from "../../../rg/api/registration-api.service";
import {Observable} from "rxjs";
import {ApiResponseDto} from "../../interfaces/core.types";
import {MessageHelper} from "../../helper/message-helper";
import {AppMessageService} from "../../service/app-message.service";


@Component({
  selector: 'forget-password-change-password',
  templateUrl: './forget-password-change-password.component.html',
  styleUrls: ['./forget-password-change-password.component.css']
})
export class ForgetPasswordChangePasswordComponent extends CoreComponent {

  @Input() formGroup: FormGroup | undefined;
  @Output() onStepComplete = new EventEmitter<number>;

  constructor(protected router: Router,
              protected registrationApiService: RegistrationApiService,
              protected messageService: AppMessageService,
              protected coreApiService: CoreApiService,
              protected signUpService: SignUpService,) {
    super();
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.initComponent();
  }

  /**
   * Initialize Component.
   */
  initComponent() {
    this.refreshComponent();
  }

  /**
   * Refresh Component.
   */
  refreshComponent() {
    this.initialized = true;
  }

  handleStepComplete() {
    this.onStepComplete.emit(3);
  }

  handleCheckPassword() {
    if (this.formGroup) {
      const password = this.formGroup.get('password')?.value;
      const dto: RegistrationRequestOtpDto = {
        phoneNumber: this.signUpService.phoneNumber as string,
        registrationGuid: this.signUpService.registrationGuid as string,
        deviceInfo: this.coreApiService.getDeviceInfo(),
        password: password as string,
      }
      this.handlePasswordMatch();

      if (password) {
        this.registrationApiService.checkPassword(dto).subscribe(res => {
          if (res.success == false) {
            this.formGroup?.get('password')?.setErrors({invalidPassword: res.data});
          } else {
            this.formGroup?.get('password')?.setErrors(null);
          }
          this.handlePasswordMatch();
        }, error => {
        })
      }
    }
  }

  handlePasswordMatch() {
    if (this.formGroup) {
      const password = this.formGroup.get('password')?.value;
      const confirmPassword = this.formGroup.get('confirmPassword')?.value;

      if (!confirmPassword || password != confirmPassword) {
        this.formGroup.get('confirmPassword')?.setErrors({passwordError: 'Die Passwörter stimmen nicht überein!'});
      } else {
        this.formGroup.get('confirmPassword')?.setErrors(null);
      }
    }
  }

  handleChangePassword() {
    this.busy = true;
    const dto: ForgotPasswordRequestDto = {
      anyUserText: this.formGroup?.get('anyUserText')?.value,
      deviceInfo: this.coreApiService.getDeviceInfo(),
      otpCode: this.formGroup?.get('otp')?.value,
      newPassword: this.formGroup?.get('password')?.value
    }
    this.registrationApiService.changeForgotPasswordViaOtp(dto).subscribe(res => {
      this.handleStepComplete();
      this.busy = false;
    }, error => {
      MessageHelper.showErrorMessage(error.error.data,this.messageService);
      this.busy = false;
    });

  // public changeForgotPasswordViaOtp(dto: ForgotPasswordRequestDto): Observable<ApiResponseDto> {
  //     return this.coreApiService.post(dto, `${this.endPoint}/changeForgotPasswordViaOtp`);
  //   }
  }


}
